import { gql } from "lib/gql-tag";
import { clients } from "utils/clients";
import { StructureEvents, Structure } from "../../Store/Structure";
import itiriri from "itiriri";

export const toEditStructureLog = async (structure: Structure, metadataStructure: any, events: StructureEvents) => {
  const { structureId, structureRootId: rootId } = metadataStructure;
  const { updateLog } = events;
  const structureUpdateQuery = itiriri(updateLog.entries())
    .toArray(([metadataId, event], index) => {
      if (event[metadataId].type === "Move") {
        return `
          structure${event[metadataId].structureId}: updateMetadata_structure(
            where: { structure_id: "${event[metadataId].structureId}" }
            data: {
              parent_id: ${event[metadataId].to === "-1" ? rootId : structureId}
              booking_order: ${event[metadataId].to === "-1" ? 0 : structure.child.length + index + 1}
            }
          ) {
            structure_id
          }
        `;
      } else {
        return `
          structure${event[metadataId].structureId}: updateMetadata_structure(
            where: { structure_id: "${event[metadataId].structureId}" }
            data: {
              booking_order: ${event[metadataId].order}
            }
          ) {
            structure_id
          }
        `;
      }
    })
    .join(" ");

  if (window.confirm("데이터를 변경하시겠습니까?")) {
    try {
      const query = gql`
        mutation UPDATE_STRUCTURE {
          ${structureUpdateQuery}
        }
      `;
      await clients.metadata.query(query);
    } catch (e) {
      throw e;
    }
  }
};
